<script setup lang="ts">
import { type PropType, watch } from 'vue'
import type { ObjectTreeItemType } from '@/entities/ObjectsTree'
import { ObjectTypes } from '@/entities/Object'
import { VIcons } from '@/shared/ui'
import { useHelpers } from '@/shared/lib'

const props = defineProps({
  item: {
    type: Object as PropType<ObjectTreeItemType>,
    required: true,
  },
})

const { updateCounter } = useHelpers()

/* Отображаемые типы */
const visible = [1, 2, 3]

/**
 * Вычисляем количество объектов каждого типа
 */
watch(
  () => props.item.children.length,
  () => {
    props.item.child_count = { ...updateCounter(props.item.children) }
  },
)
</script>

<template>
  <div class="v-tree-counter" v-if="item.type == 3">
    <template v-for="(val, key) in item.child_count" :key>
      <span class="v-tree-counter__icons" v-if="visible.includes(Number(key))">
        <VIcons :type="ObjectTypes[key].icon" />
        {{ val }}
      </span>
    </template>
  </div>
</template>
